import { render, staticRenderFns } from "./svideoinfocard.vue?vue&type=template&id=5b6e0ac6&scoped=true&"
import script from "./svideoinfocard.vue?vue&type=script&lang=js&"
export * from "./svideoinfocard.vue?vue&type=script&lang=js&"
import style0 from "./svideoinfocard.vue?vue&type=style&index=0&id=5b6e0ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e0ac6",
  null
  
)

export default component.exports